import { createFileRoute, Outlet } from "@tanstack/solid-router";
import { NotFound } from "~/components/not-found";

export const Route = createFileRoute("/_dashboard/dashboard")({
  staticData: {
    breadcrumb: "Dashboard",
  },
  // Handles not-found errors for any dashboard sub-route (e.g. an AI agent
  // linking to a route that doesn't exist, or a missing resource). Rendered
  // inside the _dashboard layout's <Outlet /> so the sidebar, header, and
  // agent chat stay visible instead of the whole layout being replaced.
  notFoundComponent: () => (
    <NotFound homeTo="/dashboard" homeLabel="Go to dashboard" />
  ),
  component: Dashboard,
});

function Dashboard() {
  return <Outlet />;
}
